import type {Message} from "@khan/guide-types";

/**
 * Represents the reason why a popover was closed.
 */
export enum PopoverClosedReason {
    /* "userDismissed" indicates that the user closed the popover. */
    userDismissed = "userDismissed",
    /* "autoDismissed" indicates that the popover was closed automatically. */
    autoDismissed = "autoDismissed",
    /* "ctaClicked" indicates that the user clicked the CTA button. */
    ctaClicked = "ctaClicked",
}

interface BaseNotification {
    /**
     * A callback that is triggered when the popover is dismissed.
     */
    onClose: (reason: PopoverClosedReason) => unknown;
}

export type NotificationStyle = "message" | "action-bubbles";
export type Notification = BaseNotification & Message;
